import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
}) => {
  const [initialFormData, setInitialFormData] = useState({});

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        comp_id: parseInt(window.localStorage.getItem("company"), 10),
        Unit_Id: 0,
        Unit_Name: "",
        Unit_Status: "Y",
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        comp_id: parseInt(selectedData.Comp_Id, 10),
        Unit_Id: parseInt(selectedData.Unit_Id, 10),
        Unit_Name: selectedData.Unit_Name,
        Unit_Status: selectedData.Unit_Status,
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertTbsetItem = async () => {
    try {
      const { Unit_Id, ...dataToInsert } = formData;

      // สร้าง fields และ values
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      // เรียกใช้ insertData
      const res = await insertData("Tb_Set_Unit", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting data:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
    }
  };

  const formatValues = (data) => {
    const { Unit_Id, ...rest } = data;
    return rest;
  };
  const handleUpdateTbsetItem = async () => {
    try {
      const where = { Unit_Id: formData.Unit_Id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Unit", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Unit",
            `WHERE Unit_Id = ${selectedData.Unit_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      // if (!formData.item_barcode || !formData.item_code || !formData.item_name || !formData.item_name_en || !formData.item_short_name ||
      //   !formData.item_unit_in || !formData.item_unit_st || !formData.item_unit_out || !formData.item_cost || !formData.item_price ||
      //   !formData.item_pricea || !formData.item_priceb || !formData.item_brand || !formData.item_series || !formData.item_group ||
      //   !formData.item_cat || !formData.item_color || !formData.item_size || !formData.item_status || !formData.item_popoint ||
      //   !formData.item_maxonhand || !formData.ap_code || !formData.item_gold || !formData.item_onhand || !formData.item_wh) {
      //   getAlert("WARNING", "โปรดกรอกข้อมูลให้ครบถ้วน");
      //   return;
      // }
      if (mode === "I") {
        await handleInsertTbsetItem();
      } else if (mode === "U") {
        await handleUpdateTbsetItem();
      }
      await callInitialize();
      setFormData({
        comp_id: parseInt(window.localStorage.getItem("company"), 10),
        Unit_Id: 0,
        Unit_Name: "",
        Unit_Status: "Y",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/tb-set-unit" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-12 mt-2">
                <label className="">หน่วยสินค้า</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="Unit_Name"
                  value={formData?.Unit_Name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="Unit_Status"
                  value={formData?.Unit_Status || "Y"} // Set default value to "Y"
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            <div className="row mt-4">
              {mode !== "I" ? (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/tb-set-unit")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateTbsetItem()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>

              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
